import React, { useState, useEffect } from "react";
import { animalAssets, createAssets } from'../../../services/constant';
import { useGlobalContext } from '../../../services/GlobalContext';
import toast from 'react-hot-toast';
import axios from 'axios';
import API_BASE_URL, { Providers } from '../../../services/Config';
const CreatePage = () => {
    const { data ,setChipChange, setloading } = useGlobalContext();
    const [animalData, setAnimalData] = useState([]);
    const [notes, setNotes] = useState(['']);

    const [isEdit, setIsEdit] = useState(false);

    const token = localStorage.getItem('authToken');
    const userData = JSON.parse(localStorage.getItem('userData'));
    const provider_id = userData['provider_id'];
    const network_id = localStorage.getItem('network_id');

    const handleClick = () => {
        isEdit ? setIsEdit(false) : setIsEdit(true);
    }

    const handleChange = (e) => {
        setNotes(e.target.value);
    }
    const handleSave = () => {
        if(notes === '')
        {
            toast.error('insira o número do microchip.');
        } else {
 
            axios.post(`${API_BASE_URL()}/v3/applications/self/${Providers()}/networks/${network_id}/policies/${data?.policies[0]?.id}/protected-assets/${data?.policies[0]?.quote?.protected_assets[0]?.id}/properties-update`, {
                "properties": [
                    {
                        "namespace": "microchip_number",
                        "data": notes
                    }
                ]
            }, {
                headers: {
                    'Authorization': 'Bearer ' + token,
                    'Content-Type': 'application/json',
                }
            }).then((res) => {
                toast.success("atualizado com sucesso.");
      
                const newAnimalData = data.policies[0].quote.protected_assets.map((item) => {
                    return {
                        name: item.properties[0].data,
                        age: item.properties[3].data,
                        type: getLabel(item.properties[1].data, item.properties[1].options),
                        gender: item.properties[2].data,
                        color: getLabel(item.properties[6].data, item.properties[6].options),
                        breed: getLabel(item.properties[5].data, item.properties[5].options),
                        microchip_number: notes,
                    };
                });
    
                setAnimalData(newAnimalData);
                setChipChange(2);
                setIsEdit(false);
            }).catch((err)=> {
                toast.error(err.code);

            })
        }
    }
    useEffect(() => {
        if (data.policies) {
            const newAnimalData = data.policies[0].quote.protected_assets.map((item) => {
                return {
                    name: item.properties[0].data,
                    age: item.properties[3].data,
                    type: getLabel(item.properties[1].data, item.properties[1].options),
                    gender: item.properties[2].data,
                    color: getLabel(item.properties[6].data, item.properties[6].options),
                    breed: getLabel(item.properties[5].data, item.properties[5].options),
                    microchip_number: item.properties[4].data,
                };
            });

            setAnimalData(newAnimalData);
        }
    }, [data]);

    const getLabel = (value, options) => {
        const option = options.find(option => option.data === value);
        return option ? option.label : "tipo desconhecido";
    };

    return (
        <div className="create_page">
            <div className="info_part">
                <div className="info_title mb-34">
                    <span className="font-color1 font-12-900 mr-1">PRINCIPAIS DADOS </span>
                    {animalData.length > 0 ? (animalData[0].microchip_number === '' || animalData[0].microchip_number === null) ? (
                        <div> 
                            {
                                isEdit ? (<button onClick={() => handleSave()} className="custom-button save_btn"><img src={createAssets.Icon_save} alt="" /></button>) : (<></>)
                            }
                            
                            <button onClick={() => handleClick()} className="custom-button edit_btn"><img src={isEdit ? createAssets.Icon_close : animalAssets.ic_edit} alt="" /></button>
                        </div>
                    ) : <></> : <></>
                    }
                </div>
                <div className=" flex-row">
                    <div className="flex-column mr-4">
                        <span className="font-color1 font-13-500 mb-2">Nome</span>
                        <span className="font-color font-14-500 font-left">{animalData.length > 0 ? animalData[0].name : ''}</span>
                    </div>
                    <div className="flex-column mr-4">
                        <span className="font-color1 font-13-500 mb-2">Espécie</span>
                        <span className="font-color font-14-500 font-left">{animalData.length > 0 ? animalData[0].type : ''}</span>
                    </div>
                    <div className="flex-column mr-4">
                        <span className="font-color1 font-13-500 mb-2">Raça</span>
                        <span className="font-color font-14-500 font-left">{animalData.length > 0 ? animalData[0].breed : ''}</span>
                    </div>
                    <div className="flex-column mr-4">
                        <span className="font-color1 font-13-500 mb-2">Sexo</span>
                        <span className="font-color font-14-500 font-left">{animalData.length > 0 ? animalData[0].gender : ''}</span>
                    </div>
                    <div className="flex-column mr-4">
                        <span className="font-color1 font-13-500 mb-2 w--100">Data de Nascimento</span>
                        <span className="font-color font-14-500 font-left">{animalData.length > 0 ? animalData[0].age : ''}</span>
                    </div>
                    <div className="flex-column">
                        <span className="font-color1 font-13-500 mb-2">Micro Chip</span>
                        {
                            isEdit ? (<input className="font-color font-14-500 font-left custom_input" value={notes} onChange={(e) => handleChange(e)}/>)
                                : (<><span className="font-color font-14-500 font-left" >{animalData.length > 0 ? animalData[0].microchip_number : notes}</span></>)
                        }

                    </div>
                </div>
            </div>
            <div className="dotline_divider mb-34"></div>
            <div className="description_part ">
                <div className="info_title mb-2">
                    <span className="font-color1 font-12-900 mr-10">OUTROS DADOS </span>
                </div>
                <div className=" flex-row mb-34">
                    <div className="flex-column mr-4">
                        <span className="font-color1 font-13-500 mb-1">Portador de qualquer incapacidade ou defeito <br></br>físico ?</span>
                        <span className="font-color font-14-500 font-left">Não</span>
                    </div>
                    <div className="flex-column mr-4">
                        <span className="font-color1 font-13-500 mb-1">teve ou tem alguma doença ou já sofreu <br></br> algum acidente ?</span>
                        <span className="font-color font-14-500 font-left">Não</span>
                    </div>
                </div>
                <div className=" flex-row">
                    <div className="flex-column mr-4">
                        <span className="font-color1 font-13-500 mb-1">Realizou intervenção cirúrgica ?</span>
                        <span className="font-color font-14-500 font-left">Não</span>
                    </div>
                </div>
            </div>
        </div>
    );
}
export default CreatePage;